import { render, staticRenderFns } from "./PromoCodeTable.vue?vue&type=template&id=29bb39b9"
import script from "./PromoCodeTable.vue?vue&type=script&lang=ts"
export * from "./PromoCodeTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports